var React = require('react');

function CloseHeaderInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.192 0.343994L5.949 4.58599L1.707 0.343994L0.292999 1.75799L4.535 5.99999L0.292999 10.242L1.707 11.656L5.949 7.41399L10.192 11.656L11.606 10.242L7.364 5.99999L11.606 1.75799L10.192 0.343994Z","fill":"black"}));
}

CloseHeaderInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CloseHeaderInline;

CloseHeaderInline.default = CloseHeaderInline;
